export const ORDER_LIST_TABLE_COLUMNS = [
    {name: "Job", mnemonic: "order_number", ui_class: "str", searchable: true, content_align: "left", shrink: true, tooltip: [{name: "Description", mnemonic: "job_description", ui_class: "str"}]},
    {name: "Shipping Mode", mnemonic: "shipping_mode_label", ui_class: "str", shrink: true},
    {name: "Status", mnemonic: "status", ui_class: "str", header_align: "center", content_align: "center", shrink: true},
    {name: "Details", mnemonic: "status_label", ui_class: "str", shrink: true},
    {name: "Created Date", mnemonic: "created_at", ui_class: "datetime", shrink: true},
    {name: "Actions", mnemonic: "uuid", ui_class: "str", header_align: "right", content_align: "right"},
];
